<template>
  <div class="app-wrapper">
      <navbar />
      <app-main />
      <Bottom />
      <FloatingButton/>
  </div>
</template>
<script>
import AppMain from '@/layouts/components/AppMain'
import Navbar from '@/layouts/components/Navbar1'
import Bottom from "@/layouts/components/Bottom"
import FloatingButton from '@/components/FloatingButton.vue'
export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Bottom,
    FloatingButton,
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
@mixin clearfix {
  &:after {
    content: "";
    display: table;
    clear: both;
  }
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/index.vue